import styled from 'styled-components';

export const GraphContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const GraphTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: end;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const GraphControls = styled.div`
  display: flex;
  margin-top: 3px;

  .MuiButtonBase-root {
    position: relative;
    top: 3px;
    background-color: #fff;
    font-size: 12px;
    text-transform: none;
    min-width: auto !important;
    height: 30px !important;

    .MuiButton-label {
      padding: 0;
    }

    .MuiSvgIcon-root {
      font-size: 14px;
      margin-right: 5px !important;
    }
  }
`;

export const ChartContainer = styled.div`
  display: flex;
  width: 100%;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  .echarts-for-react {
    width: 100%;
  }
`;
